import { render, staticRenderFns } from "./PaymentCardSvg.vue?vue&type=template&id=48ef9052&"
import script from "./PaymentCardSvg.vue?vue&type=script&lang=js&"
export * from "./PaymentCardSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports